import { LayaEnv } from "../../LayaEnv";
import { Camera2D } from "../display/Scene2DSpecial/Camera2D";
import { BaseRenderNode2D } from "../NodeRender2D/BaseRenderNode2D";
import { Texture2D } from "../resource/Texture2D";
import { Texture2DArray } from "../resource/Texture2DArray";
import { TextureCube } from "../resource/TextureCube";
import { HalfFloatUtils } from "../utils/HalfFloatUtils";
import { BlendMode } from "../webgl/canvas/BlendMode";
import { Shader2D } from "../webgl/shader/d2/Shader2D";
import { ShaderDefines2D } from "../webgl/shader/d2/ShaderDefines2D";
import { Config } from "./../../Config";
import { ILaya } from "./../../ILaya";
import { Context } from "./Context";
export class Render {
    static customRequestAnimationFrame(value, loopFun) {
        Render._customRequestAnimationFrame = value;
        Render._loopFunction = loopFun;
    }
    static set customRenderEngine(engine) {
        Render._customEngine = engine;
    }
    static get customRenderEngine() {
        return Render._customEngine;
    }
    static gc() {
        if (LayaEnv.isConch) {
            window.gc({ type: 'major', execution: 'async' });
        }
    }
    constructor(width, height, mainCanv) {
        this._first = true;
        this._startTm = 0;
        this._timeId = 0;
        Render._Render = this;
        Render._mainCanvas = mainCanv;
        let source = Render._mainCanvas.source;
        source.id = "layaCanvas";
        source.width = width;
        source.height = height;
        if (LayaEnv.isConch) {
            document.body.appendChild(source);
            Render._mainCanvas.getContext("2d");
        }
        this.initRender(Render._mainCanvas, width, height);
        if (Config._enableWindowRAFFunction) {
            window.requestAnimationFrame(loop);
        }
        else {
            requestAnimationFrame(loop);
        }
        let me = this;
        let lastFrmTm = performance.now();
        let fps = Config.FPS;
        let ifps = Render.ifps = 1000 / fps;
        function loop(stamp) {
            let sttm = performance.now();
            lastFrmTm = sttm;
            if (me._first) {
                me._startTm = Math.floor(stamp / ifps) * ifps;
                me._first = false;
            }
            stamp -= me._startTm;
            let frm = Math.floor(stamp / ifps);
            let dfrm = frm - Render.lastFrm;
            if (dfrm > 0 || !Config.fixedFrames) {
                Render.lastFrm = frm;
                ILaya.stage._loop();
            }
            if (!!Render._customRequestAnimationFrame && !!Render._loopFunction) {
                Render._customRequestAnimationFrame(Render._loopFunction);
            }
            else {
                if (Config._enableWindowRAFFunction) {
                    window.requestAnimationFrame(loop);
                }
                else {
                    requestAnimationFrame(loop);
                }
            }
        }
        ILaya.stage.on("visibilitychange", this, this._onVisibilitychange);
        LayaEnv.isConch && ILaya.timer.frameOnce(2, null, Render.gc);
    }
    _onVisibilitychange() {
        if (!ILaya.stage.isVisibility) {
            this._timeId = window.setInterval(_enterFrame, 1000);
        }
        else if (this._timeId != 0) {
            window.clearInterval(this._timeId);
        }
    }
    static vsyncTime() {
        return Render.lastFrm * Render.ifps;
    }
    initRender(canvas, w, h) {
        canvas.size(w, h);
        ShaderDefines2D.__init__();
        Context.__init__();
        var ctx = new Context();
        ctx.isMain = true;
        Render._context = ctx;
        canvas._setContext(ctx);
        Shader2D.__init__();
        BlendMode._init_();
        Texture2D.__init__();
        TextureCube.__init__();
        Texture2DArray.__init__();
        HalfFloatUtils.__init__();
        Camera2D.shaderValueInit();
        BaseRenderNode2D.initBaseRender2DCommandEncoder();
        return true;
    }
    static get context() {
        return Render._context;
    }
    static get canvas() {
        return Render._mainCanvas.source;
    }
}
Render.lastFrm = 0;
Render.ifps = 1000 / 60;
function _enterFrame() {
    ILaya.stage._loop();
}
